export default "__VITE_ASSET__CsmP$sug__"